import { render } from "./AppointmentCalendar.vue?vue&type=template&id=217bf25a&scoped=true"
import script from "./AppointmentCalendar.vue?vue&type=script&lang=js"
export * from "./AppointmentCalendar.vue?vue&type=script&lang=js"

import "./AppointmentCalendar.vue?vue&type=style&index=0&id=217bf25a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-217bf25a"]])

export default __exports__